/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Empty_HintInputs */

const en_notifications_empty_hint = /** @type {(inputs: Notifications_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When something happens in your workspace, it shows up here.`)
};

const pl_notifications_empty_hint = /** @type {(inputs: Notifications_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdy coś wydarzy się w Twojej przestrzeni roboczej, zobaczysz to tutaj.`)
};

/**
* | output |
* | --- |
* | "When something happens in your workspace, it shows up here." |
*
* @param {Notifications_Empty_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_empty_hint = /** @type {((inputs?: Notifications_Empty_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Empty_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_empty_hint(inputs)
	return en_notifications_empty_hint(inputs)
});